import { memo } from 'react';

export interface ImagePlaceholderProps {
  className?: string;
  /**
   * Color of the image placeholder.
   * @default '#A1A2A8'
   */
  color?: string;
  /**
   * Size of the image placeholder in pixels.
   * @default 70
   */
  size?: number;
}

export const ImagePlaceholder = memo(function ImagePlaceholder({ className, color = '#A1A2A8', size = 70 }: ImagePlaceholderProps) {
  return (
    <svg className={className} width={size} height={size} viewBox='0 0 70 70' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M69.75 62V7.75C69.75 3.4875 66.2625 0 62 0H7.75C3.4875 0 0 3.4875 0 7.75V62C0 66.2625 3.4875 69.75 7.75 69.75H62C66.2625 69.75 69.75 66.2625 69.75 62ZM21.3125 40.6875L31 52.3512L44.5625 34.875L62 58.125H7.75L21.3125 40.6875Z'
        fill={color}
      />
    </svg>
  );
});
